import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FpxIHttpOption, HttpProviderService,HttpRequest } from '@fpx/core';
import { DialogService } from 'src/app/fpx-core/services/dialog/dialog.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/common.service';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';
import { UserService } from 'src/app/user.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransfersResultPageService {
  resultSubmittedData:any[] = [];
  scheduleId: any;
  constructor(
    private _customerService: CustomerService,
    private _http: HttpProviderService,
    private _router: Router,
    public _dialogService: DialogService,
    private _userService: UserService,
    private _commonService: CommonService,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    private _dialog: MatDialog,
    private _httpProvider: HttpProviderService,
  ) { }



  resetTransfersResultPage(){
    this.resultSubmittedData = []
    this.scheduleId = undefined;
  }

  // 2Z6
  downloadTransferReceipt(sourceReference: string, currentDateTime: string ): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource("/transferreceipt");
    httpRequest.setMethod("GET");
    httpRequest.setServerContext(environment.transfersPublisher);
    // let payload={"currentDateTime" :currentDateTime, "sourceReference" : sourceReference, "resultPageData": resultPageData};
    // httpRequest.setBody(payload);
    // for (var i = 0; i < resultPageData.length; i++) {
    //   var key = resultPageData[i].key;
    //   payload.key=''
    // }
    httpRequest.addQueryParameter("currentDateTime", currentDateTime);
    httpRequest.addQueryParameter("sourceReference", sourceReference);
    // httpRequest.addQueryParameter("resultPageData", resultPageData);
    this._commonService.showSpinner();
    return this._httpProvider.invokeDownloadApi(httpRequest);
  }

    findByTranInternationalRefNo(key: any) {
        const httpRequest = new HttpRequest();
        httpRequest.setServerContext(environment.transfersPublisher);
        httpRequest.setResource('/transferdata/{paymentId}');
        httpRequest.addPathParameter('paymentId', key);
        httpRequest.setMethod('GET');
        return this._httpProvider
          .invokeRestApi(httpRequest)
          .pipe(map((res: any) => {
            return res;
          }));
  
      }

  }